import { Pipe, PipeTransform } from '@angular/core';
import { NomenclatureTypeEnum } from '@zaoblako/shared/modules/catalog/enums/nomenclature-type.enum';

const nomenclatureTypeNames: Record<NomenclatureTypeEnum, string> = {
  [NomenclatureTypeEnum.PRODUCT]: 'Товар',
  [NomenclatureTypeEnum.SERVICE]: 'Услуга'
};

@Pipe({
  standalone: true,
  name: 'nomenclatureTypeName'
})
export class NomenclatureTypeNamePipe implements PipeTransform {
  public transform(nomenclatureTypeName: NomenclatureTypeEnum): string {
    return nomenclatureTypeNames[nomenclatureTypeName] || '';
  }
}
